var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-card',{staticClass:"ma-0 pb-1"},[_c('custom-reports',{attrs:{"id":_vm.id,"dash-mode":true,"standard-report-identifier":_vm.standardReportIdentifier}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }